import type { FormControl, ValidatorFn } from '@angular/forms';

import type { EditorJSONState } from '@recruitee/prosemirror-types';

export function maxEditorJsonStateValidator(limit: number): ValidatorFn {
  return (control: FormControl<EditorJSONState | null>): { max: true } | null =>
    control.value && editorJsonStateLength(control.value) > limit ? { max: true } : null;
}

export const editorJsonStateLength = (state: EditorJSONState) =>
  state.doc.content.reduce(
    (paragraphLength, paragraph) =>
      paragraphLength +
      (paragraph.content || [])
        .filter(node => node.type === 'text')
        .reduce((textLength, text) => textLength + text.text.length, 0),
    0,
  );
